var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.courses.count && _vm.courses.count > 0)?_c('div',{staticClass:"row card-group-row"},_vm._l((_vm.courses.data),function(course){return _c('div',{key:'course' + course.id,staticClass:"col-sm-6 col-md-4 card-group-row__col"},[_c('CardCourse',{attrs:{"course":course}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }